(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function syncHeaderLayoutMetrics() {
    if (typeof window.setHeaderHeight === 'function') {
      window.setHeaderHeight();
    }

    const storeHeader = document.querySelector('store-header.header');
    if (!storeHeader) return;

    if (typeof storeHeader.updateHeaderHeights === 'function') {
      storeHeader.updateHeaderHeights();
    }

    if (storeHeader.dataset.isSticky === 'true' && typeof storeHeader.setHeaderEnd === 'function') {
      storeHeader.setHeaderEnd();
    }
  }

  const topbar = document.querySelector('.header__topbar[data-topbar-storage-key]');
  if (topbar) {
    const closeTopbarButton = topbar.querySelector('[data-topbar-close]');
    const topbarStorageKey = topbar.dataset.topbarStorageKey;

    if (topbarStorageKey) {
      try {
        if (window.sessionStorage.getItem(topbarStorageKey) === 'true') {
          document.documentElement.classList.add('header-topbar-dismissed');
          topbar.hidden = true;
        }
      } catch (error) {
        // sessionStorage can be disabled in private contexts.
      }
    }

    if (closeTopbarButton) {
      closeTopbarButton.addEventListener('click', () => {
        document.documentElement.classList.add('header-topbar-dismissed');
        topbar.hidden = true;
        if (topbarStorageKey) {
          try {
            window.sessionStorage.setItem(topbarStorageKey, 'true');
          } catch (error) {
            // Persisting dismiss state is best-effort.
          }
        }
        syncHeaderLayoutMetrics();
      });
    }
  }

  function scheduleHeaderMetricSync() {
    syncHeaderLayoutMetrics();
    requestAnimationFrame(syncHeaderLayoutMetrics);
    setTimeout(syncHeaderLayoutMetrics, 100);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderLayoutMetrics);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHeaderMetricSync);
  } else {
    scheduleHeaderMetricSync();
  }

  } catch(e) { console.error(e); }
})();
})();
